import { useEffect, useMemo } from "react";

const BrivityTextEditor = ({ className, id, placeholders, settings, simple, ...props }) => {
  const dataPlaceholders = useMemo(() => JSON.stringify(placeholders), [placeholders]);

  useEffect(() => {
    const editor = tinyMCE.createEditor(id, {
      ...(simple ? tinyMCE.simpleSettings : tinyMCE.settings),
      ...settings,
      selector: `#${id}`,
    });
    editor.render();
    return () => {
      tinyMCE.execCommand("mceRemoveEditor", false, id);
    };
  }, []);

  return (
    <div className={className}>
      <textarea {...props} id={id} className="tinymce" data-placeholders={dataPlaceholders} />
      <input id="file-upload" className="hidden" name="image" type="file" />
    </div>
  );
};

export default BrivityTextEditor;
